import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
import { ActivatedRoute } from '@angular/router';
declare var $;
@Component({
  selector: 'activitylist-component',
  templateUrl: './activitylist.component.html'
})
export class ActivityListComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer,
    public router:ActivatedRoute
  ) {
    super();
  }


  public Query = {
    pageNumber:1,
    pageSize:10,

    company_name:'',//買主公司
    industry_id:'', //產業
    country_ids:'', //國別代碼(多筆逗號隔開)
    keyword:'',     //採購品項
    buyer_status:'',//買主狀態
    //event
    event_type:'',  //採購案類型
    event_status:'',//採購案報名狀態
  };
  public Data;
  public PagerData;
  ngOnInit() {
    var urlParam = this.jslib.UrlParam();
    if(urlParam && urlParam['page']){
      var pn = Number(urlParam['page']);
      if(pn > 0){
        this.Query.pageNumber = pn;
      }
    }
    this.Submit();
  }
  public eventType  = this.config.eventType;
  public enrollStatus = this.config.enrollStatus;
  Submit(){
    this.QueryHandle();
    this.baseApi.apiGet('v1/event/events',this.Query).then((res)=>{
      this.Data = res['data'];
      this.Data.forEach(item => {
        var _status = this.enrollStatus[item['enrollStatus']];
        item['statusClass'] = _status['class'];
        item['statusName'] = _status['name'];
        var _evt = this.eventType[item['eventType']];
        item['typeName'] = _evt['name'];
      });
      this.PagerData = res['pager'];
    });
  }
  QueryHandle(){
    this.Query.country_ids = '';
    this.TagList.forEach(_item => {
      //報名狀態
      if(_item['main'] == 0){
        this.Query.event_status = _item['select'];
      }
      //產業
      if(_item['main'] == 1){
        this.Query.industry_id = _item['select'];
      };
      //採購案類型
      if(_item['main'] == 2){
        this.Query.event_type = _item['select'];
      }
      //買主所在地
      if(_item['main'] == 3){
        if(_item['select'] == 'continental'){
          //this.Query.continental = _item['name'];//處理州別
        }else{
          if(this.Query.country_ids != ''){
            this.Query.country_ids = this.Query.country_ids + ',' +_item['select'];
          }else{
            this.Query.country_ids = _item['select'];
          }
        }
      }
      //買主公司
      if(_item['main'] == 4){
        this.Query.company_name = _item['select'];
      }
      //採購品項
      if(_item['main'] == 5){
        this.Query.keyword = _item['select'];
      }
      //買主預約狀態
      if(_item['main'] == 6){
        this.Query.buyer_status = _item['select'];
      }
    });
  }
  SetPage(index){
    //console.log('Component SetPage',index)
    this.Query.pageNumber = index;
    this.Submit();
  }
  SetTempQuery(item){
    //console.log('SetQuery',item);
    this.tempQuery = item;
  }
  public tempQuery = {main:1,select:'',name:''};
  public TagList = [];
  public TagGroup = [];
  AddToTag(){
    if(this.tempQuery.select != ''){

      var isExist = this.TagList.find(item =>{
        return (item.main == this.tempQuery.main);
      });

      if(typeof isExist == 'undefined'){
        var _item = JSON.parse(JSON.stringify(this.tempQuery));
        this.TagList.push(_item);
        this.Submit();
      }else{
        var _item = JSON.parse(JSON.stringify(this.tempQuery));
        //買主所在地條件為累加 其餘為覆蓋
        if(_item['main'] == 3){
          var _isExist = this.TagList.findIndex((_select)=>{
            return _select['select'] == _item['select'];
          });
          if(_isExist == -1){
            this.TagList.push(_item);
          }
        }else{
          isExist.select = this.tempQuery.select;
          isExist.name = this.tempQuery.name;
        }
        this.Submit();
      }
    }
    this.TagRender();
  }
  TagRender(){
    //拿Search結構來改
    this.TagGroup = this.config.Search;
    this.TagGroup.forEach(g => {
      g['tag'] = [];
    });
    if(this.TagList && this.TagList.length > 0){
      var m = this.config.Search;
      this.TagList.forEach((tag,tag_index) => {
        tag['tag_index'] = tag_index;
        var _index = m.findIndex((_item)=>{return _item['value'] == tag['main']});
        if(_index > -1){
          this.TagGroup[_index]['tag'].push(tag);
        }
      });
    }
  }
  RemoveTag(index){
    this.TagList.splice(index, 1);
    this.Query = {
      pageNumber:1,
      pageSize:10,
      //buyer
      company_name:'',
      industry_id:'',
      country_ids:'', //國別代碼(多筆逗號隔開)
      keyword:'',
      buyer_status:'',//買主狀態
      //event
      event_type:'',
      event_status:'',
    };
    this.Submit();
    this.TagRender();
  }
}
